function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import en from './locales/RecordCompare.en.json';
import styles from './RecordCompare.module.scss';
import { Layout } from './components/Layout/RecordCompareLayout';
import HeaderRow from './components/Header/RecordCompareHeaderRow';
import MasterRow from './components/Master/RecordCompareMasterRow';
import RecordObject from './components/RecordObject/RecordCompareRecordObject';
import RecordCompareStateContext from './RecordCompareStateContext';
import { selectAll } from './util/recordCompareSelect';
import I18n from '../I18n/I18n/I18n';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import HeaderCardRow from './components/RecordObject/CardView/RecordCompareHeaderCardRow';
var MESSAGES = normalizeLocaleData(en, '@dm/components.record-compare');
export default function (_ref) {
  var _ref$allowSharing = _ref.allowSharing,
    allowSharing = _ref$allowSharing === void 0 ? false : _ref$allowSharing,
    _ref$isMergeEnabled = _ref.isMergeEnabled,
    isMergeEnabled = _ref$isMergeEnabled === void 0 ? false : _ref$isMergeEnabled,
    _ref$master = _ref.master,
    master = _ref$master === void 0 ? 0 : _ref$master,
    records = _ref.records,
    recordSecurities = _ref.recordSecurities,
    _ref$selections = _ref.selections,
    selections = _ref$selections === void 0 ? {} : _ref$selections,
    onSelectionsChange = _ref.onSelectionsChange,
    onMasterChange = _ref.onMasterChange,
    _ref$cardView = _ref.cardView,
    cardView = _ref$cardView === void 0 ? false : _ref$cardView,
    _ref$showErrors = _ref.showErrors,
    showErrors = _ref$showErrors === void 0 ? false : _ref$showErrors,
    _ref$startEmpty = _ref.startEmpty,
    startEmpty = _ref$startEmpty === void 0 ? false : _ref$startEmpty;
  var _useState = useState(startEmpty ? null : master),
    _useState2 = _slicedToArray(_useState, 2),
    masterState = _useState2[0],
    setMasterState = _useState2[1];
  var setMaster = useCallback(function (index) {
    setMasterState(index);
    onMasterChange && onMasterChange(index);
  }, [onMasterChange]);
  var _useState3 = useState(selections),
    _useState4 = _slicedToArray(_useState3, 2),
    selectionsState = _useState4[0],
    setSelectionsState = _useState4[1];
  var setSelections = useCallback(function (selections) {
    setSelectionsState(selections);
    onSelectionsChange && onSelectionsChange(selections);
  }, [onSelectionsChange]);
  var mergeSelections = useCallback(function (selections) {
    setSelections(_objectSpread({}, selectionsState, selections));
  }, [selectionsState, setSelections]);
  useEffect(function () {
    if (!startEmpty && (!selectionsState || Object.keys(selectionsState).length === 0)) {
      setSelectionsState(selectAll(master, records[master]));
    }
  }, [isMergeEnabled, master, records, selectionsState, setSelectionsState, startEmpty]);
  var recordIds = useMemo(function () {
    return records.map(function (record) {
      return record.id;
    });
  }, [records]);
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    lastSelection = _useState6[0],
    setLastSelection = _useState6[1];
  var state = useMemo(function () {
    return {
      allowSharing: allowSharing,
      selections: selectionsState,
      master: masterState,
      isMergeEnabled: isMergeEnabled,
      recordIds: recordIds,
      records: records,
      lastSelection: lastSelection,
      recordSecurities: recordSecurities,
      // deletable, editable
      selectionsState: selectionsState,
      mergeSelections: mergeSelections,
      setMaster: setMaster,
      setSelections: setSelections,
      setLastSelection: setLastSelection,
      cardView: cardView,
      showErrors: showErrors
    };
  }, [allowSharing, isMergeEnabled, lastSelection, masterState, mergeSelections, recordIds, recordSecurities, records, selectionsState, setMaster, setSelections, cardView, showErrors]);
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: MESSAGES,
    path: "RecordCompare/locales/RecordCompare",
    namespace: "@dm/components.record-compare"
  }, /*#__PURE__*/React.createElement(RecordCompareStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(Layout, {
    className: "".concat(styles.layout).concat(cardView ? " ".concat(styles['card-view']) : '')
  }, isMergeEnabled === false && /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.record-compare.messages.merge-disabled"
  })), cardView ? /*#__PURE__*/React.createElement(HeaderCardRow, null) : /*#__PURE__*/React.createElement(HeaderRow, null), isMergeEnabled && /*#__PURE__*/React.createElement(MasterRow, {
    records: records
  }), /*#__PURE__*/React.createElement(RecordObject, null), cardView && /*#__PURE__*/React.createElement(HeaderRow, null))));
}